import blog1 from './img/blog1.svg';
import blog2 from './img/blog2.svg';
import blog3 from './img/blog3.svg';
import blog4 from './img/blog4.svg';

export default [
    {
        id:1,
        image: blog1,
        title: 'Central Squaue Foundation',
        category: 'Education',
        description: 'Works to introduce innovative solutions in the education system to improve learning outcomes, in partnership with impact organisations and the Government, with special focus on foundational learning'
    },
    {
        id:2,
        image: blog2,
        title: 'Teach For India',
        category: 'Education',
        description: 'Works to introduce innovative solutions in the education system to improve learning outcomes, in partnership with impact organisations and the Government, with special focus on foundational learning'
    },
    {
        id:3,
        image: blog3,
        title: 'Hippo Campus Learning Centers',
        category: 'Education',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Neque ea, ab aperiam necessitatibus adipisci sunt facilis itaque non enim est!'
    },
    {
        id:4,
        image: blog4,
        title: 'Harmony House',
        category: 'Education',
        description: 'Provides education and vocational training to street children'
    },
    {
        id:5,
        image: blog4,
        title: 'Nav GuruKul',
        category: 'Education',
        description: 'Provides education and vocational training to street children'
    },
    {
        id:6,
        image: blog4,
        title: 'Pratham Books',
        category: 'Education',
        description: 'Creates and publishes low cost books to improve reading skills, reading fluency and learning outcomes in children'
    },
    {
        id:7,
        image: blog4,
        title: 'Bempu',
        category: 'Health',
        description: 'Works towards saving infant lives and promoting infant health in developing countries through a range of health products'
    },
    {
        id:8,
        image: blog4,
        title: 'Dimagi',
        category: 'Health',
        description: 'Provides a mobile app platform for data collection and analysis for frontline workers at the last mile, with primary focus on the health and nutrition'
    },
    {
        id:9,
        image: blog4,
        title: 'Project Mritkala',
        category: 'Health',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Neque ea, ab aperiam necessitatibus adipisci sunt facilis itaque non enim est!'
    },
    {
        id:10,
        image: blog4,
        title: 'Cope With Cancer',
        category: 'Health',
        description: 'Provides discounted investigation & treatment, non-surgical hair replacement and free counselling to cancer patients and caregivers in India.'
    },
    {
        id:11,
        image: blog4,
        title: 'Sangath',
        category: 'Health',
        description: 'Provides mental healthcare to low-income communities leveraging a low-cost operational model'
    },
    {
        id:12,
        image: blog4,
        title: 'Adiuvo Daignostics',
        category: 'Health',
        description: 'Works for developing customized portable diagnostic devices for detecting skin and soft tissue infections'
    },
    {
        id:13,
        image: blog4,
        title: 'Echoing Health Agening',
        category: 'Health',
        description: 'Works for developing customized portable diagnostic devices for detecting skin and soft tissue infections'
    },
    {
        id:14,
        image: blog4,
        title: 'Young Leaders',
        category: 'Women&Child',
        description: 'Provides training to young people in critical thinking and leadership skills to increase their participation in bringing systemic change'
    },
    {
        id:15,
        image: blog4,
        title: 'Vipla Foundation ',
        category: 'Women&Child',
        description: 'Formerly known as Save The Children India, Vipla Foundation is a 33-year-old non-profit committed to preventing exploitation and all forms of discrimination against children and vulnerable women.'
    },
    {
        id:16,
        image: blog4,
        title: 'Aarti for Girls ',
        category: 'Women&Child',
        description: 'Since its start in 1992, Aarti for Girls has been on a silent crusade against injustice to women and children in the Kadapa district of Andhra Pradesh. Operating in a region steeped in poverty and discrimination, this NGO for women has only grown from strength to strength and has impacted over 100,000 women and children across the district.'
    },
    {
        id:17,
        image: blog4,
        title: 'Swadhar IDWC ',
        category: 'Women&Child',
        description: 'Swadhar was founded in Mumbai in 1983 to help women in distress irrespective of their caste, religion, community or financial status. In 1998, Swadhar added childcare under its umbrella and became Swadhar IDWC.'
    },
    {
        id:18,
        image: blog4,
        title: 'Child Rights & You',
        category: 'Women&Child',
        description: 'With an annual disbursement budget of Rs.24.9 crore, five offices countrywide and 182 full-time employees, Child Rights and You (hitherto Child Relief and You) is one of the country’s largest child welfare NGOs. Since its promotion in 1979, CRY has defined its role as a funding agency for downstream NGOs to enable them to implement on-the-field education/child-centric projects. It currently funds over 100 voluntary organisations countrywide.'
    },
    {
        id:19,
        image: blog4,
        title: 'The Blue Cross of India ',
        category: 'Animal',
        description: 'Home to all creatures who have been abandoned, or abused and are injured or disabled, The Blue Cross of India has been rescuing animals since 1964.'
    },
    {
        id:20,
        image: blog4,
        title: 'Animal Aid Unlimited ',
        category: 'Animal',
        description: 'Started in 2002, it is a rescue center dedicated to treating ill or injured stray animals; and has rescued over 65,000 animals till date'
    },
    {
        id:21,
        image: blog4,
        title: 'People For Animals ',
        category: 'Animal',
        description: 'With an annual disbursement budget of Rs.24.9 crore, five offices countrywide and 182 full-time employees, Child Rights and You (hitherto Child Relief and You) is one of the country’s largest child welfare NGOs. Since its promotion in 1979, CRY has defined its role as a funding agency for downstream NGOs to enable them to implement on-the-field education/child-centric projects. It currently funds over 100 voluntary organisations countrywide.'
    },
    {
        id:22,
        image: blog4,
        title: 'Visakha Society for Protection and Care of Animals ',
        category: 'Animal',
        description: 'Since 1996, VSPCA has been working towards stopping the illegal trade of internationally-protected sea turtle, rescuing old and abandoned animals, and providing permanent homes to neglected or abused animals.'
    },
    {
        id:23,
        image: blog4,
        title: 'Gram Vikas Trust ',
        category: 'Community Welfare',
        description: 'Since 1996, VSPCA has been working towards stopping the illegal trade of internationally-protected sea turtle, rescuing old and abandoned animals, and providing permanent homes to neglected or abused animals.'
    },
    {
        id:24,
        image: blog4,
        title: 'Vishvodayaa Trust ',
        category: 'Community Welfare',
        description: 'Operational since 1998, Vishvodayaa Trust is a charitable organisation that promotes self-reliance and sustainable development in society with a special focus on education and auxiliary contribution in the areas of women empowerment, environment, and holistic health care.'
    },
    {
        id:25,
        image: blog4,
        title: 'Mrida Education and Welfare Society',
        category: 'Community Welfare',
        description: '‘Mrida’ in Sanskrit stands for both ‘joy’ and ‘soil’. And Mrida Education and Welfare Society has been trying to do just that with its grassroots-led development programmes among tribal communities of Mahakoshal region comprising some of the most backward districts of Madhya Pradesh.'
    },
    {
        id:26,
        image: blog4,
        title: 'Association for Sustainable Community Development ',
        category: 'Community Welfare',
        description: 'It is a non-profit voluntary organization operating in the rural areas of Tamilnadu. Our organization helps in promoting and developing the socio-economic conditions of people in rural communities.'
    },
    {
        id:27,
        image: blog4,
        title: 'Tropical Research & Development Centre ',
        category: 'Environmental Advocacy',
        description: 'With a beautiful and symbolic water droplet logo that represents precisely what the TRDC does, this environmental NGO strives to preserve natural resources for generations to come.'
    },
    {
        id:28,
        image: blog4,
        title: 'SankalpTaru Foundation',
        category: 'Environmental Advocacy',
        description: 'This environmental NGO is a classic example of how digital channels can be used in the protection and conservation of the environment. SankalpTaru is an e-NGO, which aims at promoting tree plantation across the country. The NGO is active in 21 states in India.'
    },
    {
        id:29,
        image: blog4,
        title: 'Chintan Environmental Research and Action Group ',
        category: 'Environmental Advocacy',
        description: 'Focused on promoting sustainable and equitable growth for every member of the society, Chintan works towards ensuring responsible and sustainable consumption, thus protecting the environment.'
    },
    {
        id:30,
        image: blog4,
        title: 'Help Delhi Breathe ',
        category: 'Environmental Advocacy',
        description: 'This is a non-profit environmental organization that was formed in 2015 to help bring to an end, the air pollution crisis in Delhi, India.'
    },
    
];